import React from 'react'
import { useDispatch } from 'react-redux';
import { addToCart } from '../redux/Actions/CartActions';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export const BuyNowButton = ({ product,className,onClick }) => {

  return (
    <Link to={"/checkout"} className={`mt-3 bg-[--color-button-2] group-hover/card:bg-[--color-button-3] hover:bg-[--color-button-3] hover:text-white group-hover/card:text-white text-sm font-medium py-2 px-4  rounded-full transition-all duration-300 ${className}`} onClick={()=>onClick?.()}>
      Thanh toán
    </Link>
  )
}
